import { render, staticRenderFns } from "./CreateInternalDashboard.vue?vue&type=template&id=197c1806&scoped=true"
import script from "./CreateInternalDashboard.vue?vue&type=script&lang=js"
export * from "./CreateInternalDashboard.vue?vue&type=script&lang=js"
import style0 from "./CreateInternalDashboard.vue?vue&type=style&index=0&id=197c1806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c1806",
  null
  
)

export default component.exports